import { useCallback, useEffect, useState } from 'react';
import { STORAGE_HIDDEN_NOTIFICATIONS_KEY } from '../config';
import { logger } from '../utils';
var HiddenPlatformNotificationsEventTypes;
(function (HiddenPlatformNotificationsEventTypes) {
    HiddenPlatformNotificationsEventTypes["RESET_NOTIFICATIONS"] = "RESET_NOTIFICATIONS";
})(HiddenPlatformNotificationsEventTypes || (HiddenPlatformNotificationsEventTypes = {}));
const eventBus = {
    _listeners: {},
    on(event, listener) {
        if (!eventBus._listeners[event]) {
            eventBus._listeners[event] = [];
        }
        eventBus._listeners[event].push(listener);
    },
    off(event, listener) {
        eventBus._listeners[event] = eventBus._listeners[event].filter((fn) => fn !== listener);
    },
    emit(event) {
        var _a;
        (_a = eventBus._listeners[event]) === null || _a === void 0 ? void 0 : _a.forEach((listener) => listener());
    },
};
export const useHiddenPlatformNotifications = () => {
    const [hiddenNotifications, setHiddenNotifications] = useState(() => {
        try {
            const stringifiedResult = localStorage.getItem(STORAGE_HIDDEN_NOTIFICATIONS_KEY);
            if (!stringifiedResult) {
                return [];
            }
            return JSON.parse(stringifiedResult);
        }
        catch (e) {
            logger.error('unable to parse localstorage item', e, STORAGE_HIDDEN_NOTIFICATIONS_KEY);
            return [];
        }
    });
    const isNotificationHidden = useCallback((notificationId) => hiddenNotifications.includes(notificationId), [hiddenNotifications]);
    const hideNotification = useCallback((notificationId) => {
        setHiddenNotifications((prevState) => {
            const newState = [...prevState, notificationId];
            localStorage.setItem(STORAGE_HIDDEN_NOTIFICATIONS_KEY, JSON.stringify(newState));
            return newState;
        });
    }, [setHiddenNotifications]);
    const restoreHiddenNotifications = useCallback(() => {
        setHiddenNotifications([]);
        localStorage.removeItem(STORAGE_HIDDEN_NOTIFICATIONS_KEY);
        eventBus.emit(HiddenPlatformNotificationsEventTypes.RESET_NOTIFICATIONS);
    }, [setHiddenNotifications]);
    useEffect(() => {
        const listener = () => setHiddenNotifications([]);
        eventBus.on(HiddenPlatformNotificationsEventTypes.RESET_NOTIFICATIONS, listener);
        return () => eventBus.off(HiddenPlatformNotificationsEventTypes.RESET_NOTIFICATIONS, listener);
    }, [setHiddenNotifications]);
    return { hideNotification, isNotificationHidden, restoreHiddenNotifications };
};
//# sourceMappingURL=useHiddenPlatformNotifications.js.map